import { Order } from "pages/admin/Orders"
import React, { useMemo } from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import TableContainer from "components/Common/TableContainer"
import classNames from "classnames"
import { CurrentTapType, PaymentStatus } from "./ordersType"
import { OrderStatus } from "./Components/OrderStatus"
import { PaymentState } from "./Components/PaymentStatus"
import { useTranslation } from "react-i18next"
import OrderActionMenu from "pages/admin/Orders/Components/OrderActionMenu"

interface OrdersTableProps {
  orders: Order[]
  isAllChecked: boolean
  checkedOrders: Order[]
  toggleAllOrders: () => void
  checkedOrderHandler: (order: Order) => void
  acceptHandler: (order: Order) => void
  rejectHandler: (order: Order) => void
  viewDetailsHandler: (order: Order) => void
  location?: any
}

const OrdersTable: React.FC<OrdersTableProps> = ({
  orders,
  isAllChecked,
  checkedOrders,
  toggleAllOrders,
  checkedOrderHandler,
  acceptHandler,
  rejectHandler,
  viewDetailsHandler,
  location,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onClick={toggleAllOrders}
            checked={isAllChecked}
          />
        ),
        accessor: "select",
        Cell: (cellProps: { row: { original: Order } }) => {
          return (
            <input
              onClick={() => checkedOrderHandler(cellProps.row.original)}
              checked={Boolean(
                checkedOrders.find(o => o.id === cellProps.row.original.id)
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("orders_orderId"),
        accessor: "id",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return <>{cellProps.row.original.id}</>
        },
      },
      {
        Header: t("common_createdDate"),
        accessor: "createdDate",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return <>{cellProps.row.original.createdDate}</>
        },
      },
      {
        Header: t("common_createdBy"),
        accessor: "createdBy",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return (
            <>
              <i className="bx bx-user-circle me-1" />
              {cellProps.row.original.createdBy}
            </>
          )
        },
      },
      {
        Header: t("orders_status"),
        accessor: "orderStatus",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return (
            <OrderStatus orderStatus={cellProps.row.original.orderStatus} />
            // <span>{cellProps.row.original.orderStatus}</span>
          )
        },
      },
      {
        Header: t("orders_value"),
        accessor: "orderValue",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return <>{cellProps.row.original.orderValue}</>
        },
      },
      {
        Header: t("orders_paymentStatus"),
        accessor: "paymentStatus",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return <PaymentState payment={cellProps.row.original.paymentStatus} />
        },
      },
      {
        Header: " ",
        Cell: (cellProps: { row: { original: Order } }) => {
          const order = cellProps.row.original
          return (
            <OrderActionMenu
              order={order}
              acceptHandler={acceptHandler}
              rejectHandler={rejectHandler}
              viewDetailsHandler={viewDetailsHandler}
            />
            
          )
        },
      },
    ],
    [orders, t, checkedOrders]
  )

  return (
    <TableContainer
      columns={columns}
      data={orders}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={""}
      customPageSizeOptions={undefined}
    />
  )
}

OrdersTable.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(OrdersTable))
